import { ChangeDetectorRef, Directive } from '@angular/core';
import { IsavTabs } from '../../shared/tabs/tabs';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { ChangesService } from './changes.service';
import { filter } from 'rxjs/operators';

@UntilDestroy()
@Directive({
    selector: '[isavChangesControlTabs]',
})
export class ChangesControlTabsDirective {
    constructor(
        private readonly tabs: IsavTabs,
        private readonly changesService: ChangesService,
        private readonly cdRef: ChangeDetectorRef
    ) {
        this.tabs.markAsControlled();
        tabs.activeTabChange.pipe(untilDestroyed(this)).subscribe((tab) => {
            this.checkChangesAndChangeTab(tab);
        });
    }

    private checkChangesAndChangeTab(tab: string) {
        if (this.changesService.hasChanges()) {
            this.changesService
                .warn()
                .pipe(filter((confirmed) => confirmed))
                .subscribe(() => {
                    this.tabs.activeTab = tab;
                    this.cdRef.markForCheck();
                });
        } else {
            this.tabs.activeTab = tab;
            this.cdRef.markForCheck();
        }
    }

    public forceChangeTab(tab: string) {
        this.tabs.activeTab = tab;
        this.cdRef.markForCheck();
    }
}
